import type { InternalAxiosRequestConfig } from "axios";
import type { OAuthResource } from "../../services/o-auth/index.enum";
import {
	type AxiosRequestConfigWithAuth,
	isAxiosRequestConfigWithAuth,
} from "../common/AxiosRequestConfigWithAuth";
import type { EOSEndpoint } from "./index.enum";

export interface EOSRequestConfig extends AxiosRequestConfigWithAuth {
	includeReCaptcha?: boolean;
	OAuth?: {
		enabled?: boolean;
		resource?: OAuthResource;
	};
	service?: EOSEndpoint;
}

export const isEOSRequestConfig = (
	config: InternalAxiosRequestConfig,
): config is EOSRequestConfig =>
	isAxiosRequestConfigWithAuth(config) ||
	"includeReCaptcha" in config ||
	"OAuth" in config ||
	"service" in config;
